document.addEventListener('click', function(event) {
    if (event.target.classList.contains('FaqTitle')) {
        var dataHandle = event.target.getAttribute('data-title');
        var accordionContents = document.querySelectorAll('.AccordionContent');

        for (var i = 0; i < accordionContents.length; i++) {
            if (accordionContents[i].querySelector('.StockistBox[data-handle="'+dataHandle+'"]')) {
                if (accordionContents[i].style.display === 'block') {
                    accordionContents[i].style.display = 'none';
                } else {
                    accordionContents[i].style.display = 'block';
                }
            } else {
                accordionContents[i].style.display = 'none';
            }
        }
    }
}); 
function toggleItem(elem) {
  for (var i = 0; i < elem.length; i++) {
    elem[i].addEventListener("click", function(e) {
      var current = this;
      for (var i = 0; i < elem.length; i++) {
        if (current != elem[i]) {
          elem[i].classList.remove('active');
        } else if (current.classList.contains('active') === true) {
          current.classList.remove('active');
        } else {
          current.classList.add('active')
        }
      }
      e.preventDefault();
    });
  };
}
toggleItem(document.querySelectorAll('.FaqTitle'));

var mySwiper = new Swiper('.stocklist-outer-logos-wrapper.swiper-container', {
freeMode: true,
loop: false,
slidesPerView: 6,
spaceBetween: 0,
breakpoints: {
1025: {
slidesPerView: 6,
spaceBetween: 0
},
768: {
slidesPerView: 6,
spaceBetween: 0
},
320: {
slidesPerView: 2.5,
spaceBetween: 0
}
}
});


// const slider = document.querySelector('.inner_accordion_content-wrapp');
// let isDown = false;
// let startX;
// let scrollLeft;

// slider.addEventListener('mousedown', (e) => {
//   isDown = true;
//   slider.classList.add('active');
//   startX = e.pageX - slider.offsetLeft;
//   scrollLeft = slider.scrollLeft;
// });
// slider.addEventListener('mouseleave', () => {
//   isDown = false;
//   slider.classList.remove('active');
// });
// slider.addEventListener('mouseup', () => {
//   isDown = false;
//   slider.classList.remove('active');
// });
// slider.addEventListener('mousemove', (e) => {
//   if(!isDown) return;
//   e.preventDefault();
//   const x = e.pageX - slider.offsetLeft;
//   const walk = (x - startX) * 3; //scroll-fast
//   slider.scrollLeft = scrollLeft - walk;
//   console.log(walk);
// });